import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { CalloutBox } from 'components/Docs/CalloutBox';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <CalloutBox icon="IconWarning" title="Avoid reusing deleted distinct IDs" type="caution" mdxType="CalloutBox">
      <p>{`User deletion requests are not immediate, but processed asynchronously. We recommend that you `}<em parentName="p">{`avoid`}</em>{` reusing a deleted `}<inlineCode parentName="p">{`distinct_id`}</inlineCode>{` value for a new user, as it may lead to unexpected results while the deletion is being processed. Once the deletion process is fully processed, PostHog does not retain any data associated with the deleted `}<inlineCode parentName="p">{`distinct_id`}</inlineCode>{`. `}</p>
      <p>{`If you must reuse the `}<inlineCode parentName="p">{`distinct_id`}</inlineCode>{`, you can do so using the `}<strong parentName="p">{`Reset deleted person`}</strong>{` tool, available from the dropdown at the top-right of the `}<a parentName="p" {...{
          "href": "https://app.posthog.com/persons"
        }}><strong parentName="a">{`persons page`}</strong></a>{`. This tool enables you to reset a deleted `}<inlineCode parentName="p">{`distinct_id`}</inlineCode>{` so that future events associated with it create a new person profile.  `}</p>
      <p>{`If you instead want to split a person with multiple IDs (e.g. to isolate bad data tied to a specific `}<inlineCode parentName="p">{`distinct_id`}</inlineCode>{`), use the `}<strong parentName="p">{`Split IDs`}</strong>{` button on their person profile.`}</p>
    </CalloutBox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      